module.exports = __webpack_public_path__ + "img/9788991813793.3af0996f.jpg";